<template>
    <div class="main-container w-full min-h-[90vh] bottom-8">
        <div class="fixed top-0 w-full z-50">
            <div class="z-50 relative">
                <NavBar :title="title" @minimize="minimize" @close="close"/>
            </div> 
            <div class="z-40 relative">
                <NavBarHR @openPage="selectTab"/>
            </div>
            <div class="z-30">
                <PagesTab @openPage="selectedTab" @closePage="closeTab"/>
            </div>
        </div>
        <div class="tab-content z-20 overflow-y-hidden">
            <keep-alive :include="cachedComponents">
                <component 
                    :is="activeComponent"
                 />
            </keep-alive>
        </div>
        
    </div>
</template>

<script>
import { useStore } from 'vuex';
import { ref, computed, watch } from 'vue';
import NavBar from '@/components/NavBar.vue';
import NavBarHR from '@/components/HR/NavBarHR.vue';
import PagesTab from '@/components/HR/PagesTab.vue';
import Dashboard from '@/components/HR/Dashboard.vue';
import Pay_Cycles from '@/components/HR/Pay_Cycles.vue';
import Pay_Groups from '@/components/HR/Pay_Groups.vue';
import Deductions from '@/components/HR/Deductions.vue';
import Leave_Types from '@/components/HR/Leave_Types.vue';
import Leave_Applications from '@/components/HR/Leave_Applications.vue';
import Leave_Ammendments from '@/components/HR/Leave_Ammendments.vue';
import Leave_Allocations from '@/components/HR/Leave_Allocations.vue';
import Holidays from '@/components/HR/Holidays.vue';
import Paye from '@/components/HR/Paye.vue';
import Nssf from '@/components/HR/Nssf.vue';
import Shif from '@/components/HR/Shif.vue';
import Housing_Levy from '@/components/HR/Housing_Levy.vue';
import Employees from '@/components/HR/Employees.vue';
import Employee_Biodata from '@/components/HR/Employee_Biodata.vue';
import Deduction_Details from '@/components/HR/Deduction_Details.vue';
import Employee_Details from '@/components/HR/Employee_Details.vue';
import Employee_Profile from '@/components/HR/Employee_Profile.vue';
import Import_Employees from '@/components/HR/Import_Employees.vue';
import Payrolls from '@/components/HR/Payrolls.vue';
import Payroll_Employees from '@/components/HR/Payroll_Employees.vue';
import HR_Templates from '@/components/HR/HR_Templates.vue';
import Design_HR_Template from '@/components/HR/Design_HR_Template.vue';
import Salary_Advances from '@/components/HR/Salary_Advances.vue';
import Loan_Applications from '@/components/HR/Loan_Applications.vue';
import Loan_Statement from '@/components/HR/Loan_Statement.vue';
import Loan_Application_Details from '@/components/HR/Loan_Application_Details.vue';
import Loan_Disbursements from '@/components/HR/Loan_Disbursements.vue';
import Appraisal_Categories from '@/components/HR/Appraisal_Categories.vue';
import Appraisal_Periods from '@/components/HR/Appraisal_Periods.vue';
import Performance_Indicators from '@/components/HR/Performance_Indicators.vue';
import Employee_Appraisals from '@/components/HR/Employee_Appraisals.vue';
import Appraisal_Details from '@/components/HR/Appraisal_Details.vue';
import Skill_Ratings from '@/components/HR/Skill_Ratings.vue';
import Disciplinary_Categories from '@/components/HR/Disciplinary_Categories.vue';
import Disciplinary_Cases from '@/components/HR/Disciplinary_Cases.vue';
import Disciplinary_Meetings from '@/components/HR/Disciplinary_Meetings.vue';
import Disciplinary_Reviews from '@/components/HR/Disciplinary_Reviews.vue';
import Disciplinary_Actions from '@/components/HR/Disciplinary_Actions.vue';
import Disciplinary_Appeals from '@/components/HR/Disciplinary_Appeals.vue';
import Employee_Rewards from '@/components/HR/Employee_Rewards.vue';
import Employee_Deductions from '@/components/HR/Employee_Deductions.vue';
import Asset_Categories from '@/components/HR/Asset_Categories.vue';
import Assets_List from '@/components/HR/Assets_List.vue';
import Assigned_Assets from '@/components/HR/Assigned_Assets.vue';
import Employee_Benefits from '@/components/HR/Employee_Benefits.vue'
import Reimbursements from '@/components/HR/Reimbursements.vue'
import Attendance from '@/components/HR/Attendance.vue';
import Attendance_Employees from '@/components/HR/Attendance_Employees.vue';
import Employee_Attendances from '@/components/HR/Employee_Attendances.vue';
import Projects from '@/components/HR/Projects.vue';
import Project_Allocations from '@/components/HR/Project_Allocations.vue';
import Time_Policy from '@/components/HR/Time_Policy.vue';
import Overtime_Policy from '@/components/HR/Overtime_Policy.vue';
import Employee_Overtime from '@/components/HR/Employee_Overtime.vue';
import Absenteeism from '@/components/HR/Absenteeism.vue';
import Employee_Absenteeism from '@/components/HR/Employee_Absenteeism.vue';
import Import_Deductions from '@/components/HR/Import_Deductions.vue';
import Loan_Status_Report from '@/components/HR/Loan_Status_Report.vue';
import Employee_Documents from '@/components/HR/Employee_Documents.vue';
import Loan_Topups from '@/components/HR/Loan_Topups.vue';
import Salary_Reviews from '@/components/HR/Salary_Reviews.vue';
import Daily_Attendances from '@/components/HR/Daily_Attendances.vue';

import Default_Settings from '@/components/SET/Default_Settings.vue';

export default{
    components:{
        NavBar,
        NavBarHR,
        PagesTab,
        Dashboard,
        Pay_Cycles,Pay_Groups,Deductions,Leave_Types,Holidays,Paye,Nssf,Shif,Housing_Levy,
        Employees,Employee_Biodata,Deduction_Details,Employee_Details,Import_Employees,Payrolls,Payroll_Employees,
        HR_Templates,Design_HR_Template,Leave_Applications,Leave_Allocations,Salary_Advances,Loan_Applications,
        Loan_Application_Details,Loan_Statement,Loan_Disbursements,Leave_Ammendments,Appraisal_Categories,Appraisal_Periods,Performance_Indicators,
        Employee_Appraisals,Appraisal_Details,Skill_Ratings,Disciplinary_Categories,Disciplinary_Cases,Disciplinary_Meetings,
        Disciplinary_Reviews,Disciplinary_Actions,Disciplinary_Appeals,Employee_Rewards,Employee_Deductions,Asset_Categories,Assets_List,
        Assigned_Assets,Employee_Profile,Employee_Benefits,Reimbursements,Attendance,Attendance_Employees,Employee_Attendances,Projects,
        Project_Allocations,Time_Policy,Overtime_Policy,Employee_Overtime,Absenteeism,Employee_Absenteeism,Import_Deductions,Loan_Status_Report,
        Employee_Documents,Loan_Topups,Salary_Reviews,Daily_Attendances,

        Default_Settings
    },
    props: {
        title: {
            type: String,
            required: true,
        },
    },
    setup(){
        const store = useStore();
        const title = ref('Human Resource');
        const cachedComponents = computed(() =>  Array.from(store.state.pageTab.hrArray));
        const tabs = computed({
            get: ()=> store.state.pageTab.hrArray,
        });

        const activeTab = computed(() => store.state.pageTab.hrActiveTab);
    
        const activeComponent = computed(() => activeTab.value);
    
        const selectTab = (pageName) => {
            for(const [key, value] of Object.entries(pageName)){
                store.state.pageTab.hrActiveTab = value;
            }
        };
        const selectedTab = (pageName) => {
            store.state.pageTab.hrActiveTab = pageName;
        };
        const closeTab = (pageName) =>{
            let page = {"HR":pageName};
            store.commit('pageTab/REMOVE_PAGE', page)
            store.commit(`${pageName}/RESET_SEARCH_FILTERS`)
            activeTab.value = store.state.pageTab.hrActiveTab;
            store.commit(`${pageName}/initializeStore`);
        }
        const minimize = () =>{
            store.commit('modulesTab/MINIMIZE_TAB')
        }
        const close = () =>{
            let myArray = Array.from(tabs.value);
            for(let i=0; i<myArray.length; i++){
                store.commit(`${myArray[i]}/RESET_SEARCH_FILTERS`)
                store.commit(`${myArray[i]}/initializeStore`)
            }
            store.commit('modulesTab/REMOVE_TAB', {'HR':'Human Resource'}),
            store.commit('pageTab/CLEAR_PAGE_TAB', 'Human Resource');
            activeTab.value = store.state.pageTab.hrActiveTab;
        }
        return{
            close,minimize,title,activeComponent,selectTab, selectedTab, closeTab,activeTab, cachedComponents
        }
    },
    mounted(){
        const store = useStore();
        this.activeTab = store.state.pageTab.hrActiveTab;
    }
}
</script>

<style>
.tab-content{
    margin-top: 35px;
}
.main-container{
    max-height: 100vh;
    overflow: hidden;
}

</style>